<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card>
        <v-card color="#FFD375" class="elevation-12">
            <v-toolbar color="#FFA500">
                <v-toolbar-title>{{title}}</v-toolbar-title>
            </v-toolbar>

            <v-card color="#FFD375" flat class="elevation-12">
                <v-toolbar class="mt-1" color="#FFA500" flat>
                    <v-toolbar-title flat>Available</v-toolbar-title>
                </v-toolbar>
                <v-container :key="selected.length">
                    <span v-for="chip in available" :key="chip.ID">
                        <v-chip class="ma-1" @click="chipAvailableClick(chip)">{{chip.Name}}</v-chip>
                    </span>
                </v-container>
            </v-card>

            <v-card color="#FFD375" flat class="elevation-12">
                <v-toolbar class="mt-1" color="#FFA500" flat>
                    <v-toolbar-title flat>Selected</v-toolbar-title>
                </v-toolbar>
                    <v-container :key="selected.length">
                        <span v-for="chip in selected" :key="chip.ID">
                            <v-chip class="ma-1" @click="chipSelectedClick(chip)">{{chip.Name}}<v-icon right>highlight_off</v-icon></v-chip>
                        </span>
                    </v-container>
            </v-card>

            <v-card-actions>
                <v-btn color="#FFA500" @click="cancel" data-cy="joinSubmitBtn">CANCEL</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="#FFA500" :disabled="!changed" @click="submit" data-cy="joinSubmitBtn">CONFIRM</v-btn>
            </v-card-actions>
        </v-card>
        </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
      value: Boolean,
      listdata:Object
  },
  data() {
      return {
          changed: false,
          available: [],
          selected: [],
          originalselected:[]
      };
  },
  computed: {
    show: {
      get () {
        this.initialiseData();
        return this.value
      },
      set(value) {
        this.changed = false;
        this.$emit('input', value)
      }
    },
      title() {
          if (!this.listdata)
              return '';
        return this.listdata.title;
    }
    
  },
  methods: {
      initialiseData() {
          if ((this.listdata) && (!this.changed)) {
              this.selected = [];
              this.available = [];
              this.originalselected = [];
              //go through all possibles and put them into available or selected
              this.listdata.possible.forEach(item => {
                  if (this.isSelected(item.ID)) {
                      this.selected.push({ Name: item.Name, ID: item.ID });
                      this.originalselected.push(item);
                  }
                  else
                      this.available.push({ Name: item.Name, ID: item.ID })
              });
              this.available.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
              this.selected.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
          }
      },
      isSelected(id) {
          if ((this.listdata == null) || (this.listdata.possible == null) || (this.listdata.selected == null))
              return false;
          var found = false;
          this.listdata.selected.forEach(itm => {
              if (id === itm)
                  found=true;
          });
          return found;
      },
      findIndex(id, list) {
          var index = 0;
          var found = -1;
          if (list == null)
              return -1;
          list.forEach(grp => {
              if (id === grp)
                  found = index;
              index++;
          });
          return found;
      },
      chipAvailableClick(chip) {
          if (this.listdata.type === "share.survey")
              if (this.selected.length > 0) {
                  this.available.push(this.selected[0]);
                  this.available.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
                  this.selected.splice(0, 1);
                }
          const index = this.available.indexOf(chip);
          this.available.splice(index, 1);
          this.selected.push(chip);
          this.selected.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
          this.changed = true;
      },
      chipSelectedClick(chip) {
          const index = this.selected.indexOf(chip);
          this.selected.splice(index, 1);
          this.available.push(chip);
          this.available.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
          this.changed = true;
      },
      cancel(){
          this.show = false;
          this.$store.state.sharepopup.fromlist = true;
          this.$store.state.sharepopup.show = true;
      },
      submit() {
          if (this.listdata.type === "share.survey") {
              if (this.selected.length == 0)
                  this.listdata.output.Survey = null;
              else
                  this.listdata.output.Survey = this.selected[0].ID;
          }
          if (this.listdata.type === "share.contacts") {
              this.listdata.output.Contacts = [];
              this.selected.forEach(itm => {
                  this.listdata.output.Contacts.push(itm.ID);
              });
          }
          if (this.listdata.type === "share.groups") {
              this.listdata.output.Groups = [];
              this.selected.forEach(itm => {
                  this.listdata.output.Groups.push(itm.ID);
              });
          }
          this.$store.state.updatecount++;
          this.show = false;
          this.$store.state.sharepopup.fromlist = true;
          this.$store.state.sharepopup.show = true;
        }
  }
}
</script>